import { useCallback, useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight, ZoomIn } from "lucide-react";
import { NewBadge } from "@/components/NewBadge";
import { Lightbox } from "@/components/Lightbox";

const hoverZoom = (e) => {
  const r = e.currentTarget.getBoundingClientRect();
  e.currentTarget.style.setProperty("--zx", `${((e.clientX - r.left) / r.width) * 100}%`);
  e.currentTarget.style.setProperty("--zy", `${((e.clientY - r.top) / r.height) * 100}%`);
};

export const ProductGallery = ({ product, lead = "" }) => {
  const base = [product.image, ...(product.images || [])].filter(Boolean);
  const photos = lead ? [lead, ...base.filter(src => src !== lead)] : base;
  const track = useRef(null);
  const [active, setActive] = useState(0);
  const [zoomAt, setZoomAt] = useState(null);
  const closeZoom = useCallback(() => setZoomAt(null), []);

  useEffect(() => { setActive(0); track.current?.scrollTo({ left: 0 }); }, [product.id, lead]);

  const go = (i) => {
    const el = track.current;
    if (!el) return;
    const next = (i + photos.length) % photos.length;
    el.scrollTo({ left: next * el.clientWidth, behavior: "smooth" });
    setActive(next);
  };
  const onScroll = () => {
    const el = track.current;
    if (el) setActive(Math.round(el.scrollLeft / el.clientWidth));
  };

  return (
    <div className="product-media gallery" data-testid="product-gallery">
      <div className="gallery-frame">
        <div className="gallery-track" ref={track} onScroll={onScroll} data-testid="gallery-track">
          {photos.map((src, i) => (
            <div key={src + i} className="gallery-slide" onMouseMove={hoverZoom} onClick={() => setZoomAt(i)} data-testid={`gallery-slide-${i}`}>
              <img src={src} alt={`${product.name} ${i + 1}`} data-testid={i === 0 ? "product-main-image" : `gallery-image-${i}`} />
            </div>
          ))}
        </div>
        <span className="gallery-zoom-hint" data-testid="gallery-zoom-hint"><ZoomIn size={13} /> Tap to zoom</span>
        <NewBadge product={product} className="on-media" />
        {photos.length > 1 && (
          <>
            <button type="button" className="gallery-arrow left" onClick={() => go(active - 1)} aria-label="Previous photo" data-testid="gallery-prev"><ChevronLeft size={18} /></button>
            <button type="button" className="gallery-arrow right" onClick={() => go(active + 1)} aria-label="Next photo" data-testid="gallery-next"><ChevronRight size={18} /></button>
            <span className="gallery-count" data-testid="gallery-count">{active + 1} / {photos.length}</span>
          </>
        )}
      </div>
      {photos.length > 1 && (
        <div className="gallery-thumbs" data-testid="gallery-thumbs">
          {photos.map((src, i) => (
            <button type="button" key={src + i} className={i === active ? "active" : ""} onClick={() => go(i)} data-testid={`gallery-thumb-${i}`}><img src={src} alt="" /></button>
          ))}
        </div>
      )}
      {zoomAt !== null && <Lightbox photos={photos} start={zoomAt} name={product.name} onClose={closeZoom} />}
    </div>
  );
};
